import { render, staticRenderFns } from "./PostSettings.vue?vue&type=template&id=4d8435f4&scoped=true&"
import script from "./PostSettings.vue?vue&type=script&lang=js&"
export * from "./PostSettings.vue?vue&type=script&lang=js&"
import style0 from "./PostSettings.vue?vue&type=style&index=0&id=4d8435f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8435f4",
  null
  
)

export default component.exports